const email = (value: string) => {
  return /\S+@\S+\.\S+/.test(value);
};

const validate = {
  email,
};

export default validate;
